/** InsCoder 2026-09-16 B + HP 26 product cards single: tabs + swiper + buy button loading **/
(function () {
  'use strict';

  var ROOT_SELECTOR = '.hp_26_pcs';
  var SLIDER_SELECTOR = '[data-hp26-swiper]';

  function initSection(root) {
    if (!root || root.dataset.hp26Ready === 'true') return;

    var sliderEl = root.querySelector(SLIDER_SELECTOR);
    if (!sliderEl) return;
    root.dataset.hp26Ready = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-hp26-tab]'));
    var prevBtn = root.querySelector('[data-hp26-prev]');
    var nextBtn = root.querySelector('[data-hp26-next]');
    var swiperInstance = null;
    /** InsCoder 2026-09-21 B + Tab to open on page load, resolved in Liquid from the section setting **/
    var initialTab = Number(root.dataset.hp26InitialTab) || 0;
    /** InsCoder 2026-09-21 E + Tab to open on page load, resolved in Liquid from the section setting **/

    function setActiveTab(index) {
      tabs.forEach(function (tab) {
        var isActive = Number(tab.dataset.hp26Tab) === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });
    }

    function initSwiper() {
      if (!window.Swiper || !sliderEl.querySelector('.swiper-slide')) return;

      swiperInstance = new window.Swiper(sliderEl, {
        initialSlide: initialTab,
        slidesPerView: 1,
        spaceBetween: 0,
        watchOverflow: true,
        /** InsCoder WANG.J 2026-09-22 B + Mobile: 1.2 cards per view + 12px gutter, so Swiper derives the card width from the viewport instead of a fixed 280px (Figma 18315:30496) **/
        breakpoints: {
          0: { slidesPerView: 1.2, spaceBetween: 12 },
          990: { slidesPerView: 1, spaceBetween: 0 }
        },
        /** InsCoder WANG.J 2026-09-22 E + Mobile: 1.2 cards per view + 12px gutter, so Swiper derives the card width from the viewport instead of a fixed 280px (Figma 18315:30496) **/
        on: {
          slideChange: function () {
            setActiveTab(this.activeIndex);
          }
        }
      });

      setActiveTab(initialTab);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var index = Number(tab.dataset.hp26Tab) || 0;
        if (swiperInstance) swiperInstance.slideTo(index);
        setActiveTab(index);
      });

      tab.addEventListener('keydown', function (event) {
        var direction = 0;
        if (event.key === 'ArrowRight') direction = 1;
        if (event.key === 'ArrowLeft') direction = -1;
        if (!direction || tabs.length < 2) return;

        event.preventDefault();
        var current = tabs.indexOf(tab);
        var target = tabs[(current + direction + tabs.length) % tabs.length];
        target.focus();
        target.click();
      });
    });

    /** InsCoder 2026-09-17 B + Buy button loading state only (add to cart / checkout is handled by the global .checkoutButton flow in theme.js) **/
    function setLoading(button) {
      if (button.classList.contains('is-loading')) return;
      if (button.getAttribute('aria-disabled') === 'true') return;
      button.classList.add('is-loading');
    }

    function clearLoading() {
      root.querySelectorAll('[data-hp26-atc].is-loading').forEach(function (button) {
        button.classList.remove('is-loading');
      });
    }

    root.querySelectorAll('[data-hp26-atc]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        setLoading(button);
      });
    });

    // Clear the stuck loading state when the page is restored from bfcache (browser back)
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) clearLoading();
    });
    /** InsCoder 2026-09-17 E + Buy button loading state only (add to cart / checkout is handled by the global .checkoutButton flow in theme.js) **/

    /** InsCoder WANG.J 2026-09-22 B + Nav buttons wrap around instead of being disabled at either end **/
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (!swiperInstance) return;
        if (swiperInstance.isBeginning) swiperInstance.slideTo(swiperInstance.slides.length - 1);
        else swiperInstance.slidePrev();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (!swiperInstance) return;
        if (swiperInstance.isEnd) swiperInstance.slideTo(0);
        else swiperInstance.slideNext();
      });
    }
    /** InsCoder WANG.J 2026-09-22 E + Nav buttons wrap around instead of being disabled at either end **/

    initSwiper();
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (!target || !target.querySelector) return;

    var root = target.classList && target.classList.contains('hp_26_pcs')
      ? target
      : target.querySelector(ROOT_SELECTOR);

    if (root) initSection(root);
    else initAll();
  });
})();
/** InsCoder 2026-09-16 E + HP 26 product cards single: tabs + swiper + buy button loading **/
